import api from "./api";

const pesquisaService = {
    verificarEnvioAnterior: async () => {
        const response = await api.get(`/admin/verificar-resposta`);
        return response.data;
    },

    fetchPerguntas: async () => {
        const response = await api.get(`/admin/listar-perguntas`);
        return response.data;
    },

		enviarRespostas: async (respostasArray) => {
			try {
        const response = await api.post('/admin/respostaspesquisa', {
            respostas: respostasArray, // Envia as respostas como array
					});
					// return response.data;
					console.log('Respostas submetidas com sucesso:', response.data);
    } catch (error) {
        if (error.response && error.response.status === 422) {
            console.error('Erro de validação:', error.response.data.errors);
        }
        throw error;
    }
	}
	
};

export default pesquisaService;
